import clsx from "clsx";
import "./Button.scss";

type ButtonProps = {
  icon?: React.ReactNode;
  iconOnly?: boolean;
  variant?: "primary" | "secondary" | "error" | "success" | "warning";
  appearance?: "normal" | "muted" | "outline" | "link";
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Button = ({
  children,
  variant = "primary",
  appearance = "normal",
  disabled = false,
  icon,
  iconOnly,
  ...props
}: ButtonProps) => {

  return (
    <button className={clsx("button", variant, appearance, {"icon-only": iconOnly})} disabled={disabled} {...props}>
      {icon && <span className="icon">{icon}</span>}
      {children && <span className="value">{children}</span>}
    </button>
  );
};
